import * as math from 'mathjs';

/**
 * make_auswahl(n, vals)
 * Returns an n-by-(m^n) matrix containing all combinations of the
 * elements in vals (default [1 0 -1]) in the same order as nested
 * loops: i1 changes slowest, last index changes fastest.
 * 
 * @param {number} n - Number of dimensions
 * @param {Array} vals - Values to combine (default [1, 0, -1])
 * @returns {Matrix} n-by-(m^n) matrix with all combinations
 */
class MakeAuswahl {
    run(n, vals) {
        // Default vals = [1, 0, -1] (note: MATLAB uses 1:-1:-1 which is [1, 0, -1])
        if (!vals || vals.length === 0) {
            vals = [1, 0, -1];
        }
        
        if (n < 1) {
            throw new Error('n must be >= 1');
        }
        
        let m = vals.length;
        
        // Start with 1D combinations (1 x m)
        // MATLAB: auswahl = reshape(vals(:), 1, []) - creates 1-by-m matrix
        let auswahl = math.matrix([vals]); // 1-by-m matrix
        
        // If n == 1, we're done - return 1-by-m matrix
        if (n === 1) {
            return auswahl;
        }
        
        // Iteratively prepend the next outer-loop variable
        for (let k = 2; k <= n; k++) {
            let prev = auswahl;
            let cols_prev = prev.size()[1];
            let total_cols = m * cols_prev; // = m^k
            let new_auswahl = math.zeros(k, total_cols);
            
            let idx = 0;
            for (let vi = 0; vi < m; vi++) { // outer loop over vals (i1)
                let v = vals[vi];
                for (let j = 0; j < cols_prev; j++) { // iterate previous combinations in order
                    // new(:, idx) = [v; prev(:, j)]
                    // MATLAB: new(:, idx) = [v; prev(:, j)]
                    new_auswahl = math.subset(new_auswahl, math.index(0, idx), v);
                    for (let row = 0; row < k - 1; row++) {
                        let prev_val = math.subset(prev, math.index(row, j));
                        new_auswahl = math.subset(new_auswahl, math.index(row + 1, idx), prev_val);
                    }
                    idx = idx + 1;
                }
            }
            auswahl = new_auswahl;
        }
        
        return auswahl;
    }
}

export default MakeAuswahl;

